import React from "react";
import Login from "pages/Admin/Authentication/Login";
import Register from "pages/Admin/Authentication/Register";
import Resetpassword from "pages/Admin/Authentication/Resetpassword";
import ForgetPassword from "pages/Admin/Authentication/ForgetPassword";
import Logout from "pages/Admin/Authentication/Logout";
import Pages404 from "pages/Utility/pages-404";
import Home from "pages/Utility/home";
import Pages500 from "pages/Utility/pages-500";
import AdminDashBoard from "pages/Admin/Dashboard"
import CitiesPage from "pages/Admin/Settings/Cities"
import CriteriasPage from "pages/Admin/Settings/Criteria"
import { Redirect } from "react-router-dom"
import UnitTypesPage from "pages/Admin/Settings/UnitTypes"
import CategoriesPage from "pages/Admin/Settings/Categories"
import FinishingTypesPage from "pages/Admin/Settings/FinishingTypes"
import FacilitiesPage from "pages/Admin/Settings/Facilities"
import AreasPage from "pages/Admin/Settings/Areas"
import RolesPage from "pages/Admin/Settings/Roles"
import CreateRolePage from "pages/Admin/Settings/Roles/create"
import UpdateRolePage from "pages/Admin/Settings/Roles/update"
import AdminsPage from "pages/Admin/Admins"
import DeveloperPage from "pages/Admin/Developer"
import CreateDeveloperPage from "pages/Admin/Developer/create"
import UpdateDeveloperPage from "pages/Admin/Developer/update"
import PaymentPage from "pages/Admin/Settings/Payment"
import DeveloperProfilePage from "pages/Admin/Developer/Profile";
import CompoundPage from "pages/Admin/Compound/AddCompound"
import CompoundList from "pages/Admin/Compound";
import EditCompound from "pages/Admin/Compound/EditCompound"
import AddBuilding from "pages/Admin/Compound/AddBuilding"
import AddProperty from "pages/Admin/Compound/AddProperty"
import CreateResale from "pages/Admin/Resale/CreateResale"
import ViewResale from "pages/Admin/Resale/View"

import ResalePage from "pages/Admin/Resale"
import MasterPlan from "pages/Admin/MasterPlan"
import BuildingList from "pages/Admin/Building"
import EditBuilding from "pages/Admin/Building/EditBuilding"
import CreateBuilding from "pages/Admin/Building/CreateBuilding"
import PropertyList from "pages/Admin/Property"
import EditProperty from "pages/Admin/Property/EditProperty"
import CreateProperty from "pages/Admin/Property/CreateProperty"
import PaymentPlan from "pages/Admin/PaymentPlan"
import AddPayment from "pages/Admin/PaymentPlan/AddPayment"
import SalesRepPage from "pages/Admin/SalesRep"
import SellerPage from "pages/Admin/Seller"
import RattingPage from "pages/Admin/Ratting"
import Profile from "pages/Admin/SalesRep/Profile"
import InteractiveModePage from "pages/Admin/InteractiveModePage"
import UserMode from "pages/Admin/InteractiveModePage/UserIteractiveMode"
import LeadsPage from "pages/Admin/Leads"
import DealsPage from "pages/Admin/Deals"
import AppoinmentsPage from "pages/Admin/Appoinments"
import AddLeadPage from "pages/Admin/Leads/AddLead"
import AddDealPage from "pages/Admin/Deals/AddDeal"
import EditDealPage from "pages/Admin/Deals/EditDeal"
import AddAppoinmentPage from "pages/Admin/Appoinments/AddAppoinment"
import ViewAppoinmentsPage from "pages/Admin/Appoinments/ViewAppoinment"

import AddActivityPage from "pages/Admin/Leads/AddActivity"
import AddActivityPageDeal from "pages/Admin/Deals/AddActivity"

import ViewLeadPage from "pages/Admin/Leads/ViewLead"
import ViewDealPage from "pages/Admin/Deals/ViewDeal"
import InviteSalesRep from "pages/Admin/SalesRep/InviteSalesRep"
// import UpdateAdminPage from "pages/Admin/SalesRep/update"ViewAppoinmentsPage
import InteractiveMode from "pages/Admin/InteractiveMode"
import AddMode from "pages/Admin/InteractiveMode/AddMode"
import UserModePage from "pages/Admin/InteractiveMode/UserMode"
import Activities from "pages/Admin/Dashboard/Activities";
import ManageClients from "pages/Admin/ManageClients";
import CreateClientPage from "pages/Admin/ManageClients/Create";
import UnitSizes from "pages/Admin/Settings/UnitSizes";
import SalesDeveloperPage from "pages/Admin/SalesDeveloper";
import CreateSalesDeveloperPage from "pages/Admin/SalesDeveloper/create";
import UpdateSalesDeveloperPage from "pages/Admin/SalesDeveloper/update";
import ManageInventory from "pages/Admin/Settings/Inventory";
import Wirframe from "pages/Admin/Settings/Inventory/Wirframe";
import CountriesPage from "pages/Admin/Settings/Countries";
import Cards from "pages/Admin/Compound/Cards";
import Campaign from "pages/Admin/Campaign";
import FacingPage from "pages/Admin/Settings/Facing";
import AmenitiesPage from "pages/Admin/Settings/Amenities";

const adminRoutes = [
  { path: "/logout", component: Logout },

  { path: "/pages-404", component: Pages404 },
  { path: "/dashboard", component: AdminDashBoard },
  { path: "/campaign", component: Campaign },
  { path: "/home", component: Home },

  { path: "/setting/cities", component: CitiesPage },
  { path: "/setting/unit-types", component: UnitTypesPage },
  { path: "/setting/unit-sizes", component: UnitSizes },
  { path: "/setting/categories", component: CategoriesPage },
  { path: "/setting/finishing-types", component: FinishingTypesPage },
  { path: "/setting/facilities", component: FacilitiesPage },
  { path: "/setting/countries", component: CountriesPage },
  { path: "/setting/facing", component: FacingPage },
  { path: "/setting/areas", component: AreasPage },
  { path: "/setting/amenities", component: AmenitiesPage },
  { path: "/setting/Payment", component: PaymentPage },
  { path: "/setting/criteria", component: CriteriasPage },
  { path: "/setting/roles", component: RolesPage },
  { path: "/setting/roles/roles-create", component: CreateRolePage },
  { path: "/setting/roles/roles-update/:id", component: CreateRolePage },
  { path: "/setting/inventory", component: ManageInventory },
  { path: "/setting/inventory/wirframe", component: Wirframe },

  { path: "/Admins", component: AdminsPage },
  { path: "/Admin-developer", component: DeveloperPage },
  { path: "/developer-profile/:id", component: DeveloperProfilePage },
  { path: "/Admin-developer/developer-create", component: CreateDeveloperPage },
  { path: "/Admin-developer/developer-update/:id", component: UpdateDeveloperPage },
  { path: "/sales-developer", component: SalesDeveloperPage },
  { path: "/sales-developer/sales-developer-create", component: CreateSalesDeveloperPage },
  { path: "/sales-developer/sales-developer-update/:id", component: UpdateSalesDeveloperPage },
  { path: "/Admin-developer/compound", component: CompoundPage },
  { path: "/Admin-developer/compound-list/:id", component: CompoundList },
  { path: "/Admin-developer/compound-update/:id", component: EditCompound },
  { path: "/Admin-developer/cards/:id", component: Cards },
  { path: "/Admin-developer/create-building/:id", component: AddBuilding },
  { path: "/Admin-developer/edit-building/:id", component: EditBuilding },
  { path: "/Admin-developer/building", component: BuildingList },
  { path: "/Admin-developer/add-building", component: CreateBuilding },
  { path: "/create-property", component: AddProperty },
  { path: "/Admin-developer/property", component: PropertyList },
  { path: "/Admin-developer/add-property/:id?/:name?", component: CreateProperty },
  { path: "/Admin-developer/edit-property/:id", component: EditProperty },
  { path: "/resale", component: ResalePage },
  { path: "/resale/create-resale/:id?", component: CreateResale },
  { path: "/resale/view-resale/:id?", component: ViewResale },
  { path: "/resale/edit-resale/:id?", component: CreateResale },
  { path: "/interactive-mode", component: InteractiveModePage },
  { path: "/user-mode", component: UserMode },
  { path: "/interactive", component: InteractiveMode },
  { path: "/interactive/add-mode", component: AddMode },
  { path: "/UserMode", component: UserModePage },

   // { path: "/view-resale/id", component: ResalePage },

  { path: "/leads", component: LeadsPage },
  { path: "/leads/add-lead", component: AddLeadPage },
  { path: "/leads/view-lead/:id", component: ViewLeadPage },

  { path: "/deals/add-deal/:id?/:owner?", component: AddDealPage },
  { path: "/deals/Edit-deal/:id", component: EditDealPage },


  { path: "/leads/add-activity/:id/:type/:owner?", component: AddActivityPage }, 
  { path: "/leads/add-activity/:ids", component: AddActivityPage }, 
  { path: "/deals/deal-activity/:id/:leadId/:owner?", component: AddActivityPageDeal },  
  { path: "/deals/deal-activity/:ids", component: AddActivityPageDeal },  

  { path: "/deals", component: DealsPage },
  { path: "/deals/view-deal/:id", component: ViewDealPage },
  { path: "/appoinments", component: AppoinmentsPage },
  { path: "/appoinments/view-appoinment/:id", component: ViewAppoinmentsPage },
  { path: "/appoinments/book-appoinment/:id?/:leadId?/:owner?", component: AddAppoinmentPage },
  { path: "/appoinments/edit-appoinment/:id?", component: AddAppoinmentPage },

  { path: "/master-plan", component: MasterPlan },
  { path: "/payment-plan", component: PaymentPlan },
  { path: "/payment-plan/create-payment/:id?", component: AddPayment }, 
  { path: "/payment-plan/:id", component: PaymentPlan },

  { path: "/sales-rep", component: SalesRepPage },
  { path: "/sales-rep/invite-sales-rep/:id?", component: InviteSalesRep },
  { path: "/sales-rep/sales-rep-profile/:id", component: Profile },
  // { path: "/sales-rep/update/:id", component: UpdateAdminPage },

  { path: "/rates", component: RattingPage },
  { path: "/manage-clients", component: ManageClients },
  { path: "/manage-clients/add-client", component: CreateClientPage },
  { path: "/seller", component: SellerPage },
  { path: "/activities", component: Activities },


  { path: "*", component: () => <Redirect to='/admin/pages-404' /> },
  // this route should be at the end of all other routes
];

const adminAuthRoutes = [
  { path: "/login", component: Login },
  { path: "/signup", component: Register },
  { path: "/forget-password", component: ForgetPassword },
  { path: "/reset-password", component: Resetpassword },
  { path: "/pages-500", component: Pages500 },
];

export { adminRoutes, adminAuthRoutes };
